<template>
  <m-input-select
    :label="this.$t('common.dataType')"
    :options="dataTypeOptions"
    :help-danger="helpDanger"
    :value="dataTypes[0]"
    :disabled="disabled"
    :fullwidth="fullwidth"
    @input="handleDataTypeSelect"
  />
</template>

<script>
  import { MInputSelect } from 'codefabrik-gui-vue'

  export default {
    name: 'DataTypeSelect',
    components: { MInputSelect },
    props: {
      helpDanger: {
        type: String,
        default: null
      },
      disabled: {
        type: Boolean,
        default: false
      },
      fullwidth: Boolean,
    },
    computed: {
      dataTypes() {
        return ["Boolean", "Integer", "Float", "String"]
      },
      dataTypeOptions () {
        this.handleDataTypeSelect(this.dataTypes[0])
        return this.dataTypes.map(it => {
          return { value: it, label: it }
        })
      },
    },
    methods: {
      handleDataTypeSelect (newValue) {
        this.$emit('input', newValue)
      },
    },
  }
</script>

<style scoped>

</style>
